var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "li",
    {
      staticClass: "nav notification-card",
      class: "notification-card--" + _vm.notificationType.class,
      attrs: {
        id: "notification-" + _vm.notification.id,
        "data-id": "notification-card-item"
      }
    },
    [
      _c("span", { staticClass: "notification-card__type" }, [
        _c("i", { class: "icon icon-" + _vm.notificationType.icon })
      ]),
      !_vm.notification.shown
        ? _c("span", { staticClass: "notification-card__close" }, [
            _c(
              "button",
              {
                staticClass: "notification-card__close-btn",
                attrs: { "data-id": "notification-close-button" },
                on: { click: _vm.closeAction }
              },
              [_c("i", { staticClass: "icon icon-remove" })]
            )
          ])
        : _vm._e(),
      _c("div", {
        staticClass: "notification-card__content",
        class: [
          "notification-card__content",
          _vm.hasLongWord && "include-long-word"
        ],
        attrs: { "data-id": "notification-content" },
        domProps: { innerHTML: _vm._s(_vm.parsedHtml) }
      }),
      _c("div", { staticClass: "notification-card__date" }, [
        _c(
          "span",
          {
            staticClass: "notification-card__created-date",
            attrs: { "data-id": "notification-created-date" }
          },
          [
            _vm._v(
              " Created on: " +
                _vm._s(_vm.formatDateTime(_vm.notification.datetimeStamp)) +
                " "
            )
          ]
        ),
        _vm.notification.dismissed && _vm.notification.dismissedOn
          ? _c(
              "span",
              {
                staticClass: "notification-card__dismissed-date",
                attrs: { "data-id": "notification-dismissed-date" }
              },
              [
                _vm._v(
                  " Dismissed on: " +
                    _vm._s(_vm.formatDateTime(_vm.notification.dismissedOn)) +
                    " "
                )
              ]
            )
          : _vm._e()
      ]),
      !_vm.notification.dismissed
        ? _c("div", { staticClass: "notification-card__actions" }, [
            _c(
              "a",
              {
                staticClass: "notification-card__save-btn",
                attrs: { "data-id": "notification-save-button" },
                on: { click: _vm.saveAction }
              },
              [_vm._v(" Save & Dismiss ")]
            ),
            _c(
              "a",
              {
                directives: [
                  {
                    name: "log",
                    rawName: "v-log",
                    value: {
                      target: "Dismiss Notification Link",
                      event: "click",
                      eventData: _vm.notification
                    },
                    expression:
                      "{\n\t\t\t\ttarget: 'Dismiss Notification Link',\n\t\t\t\tevent: 'click',\n\t\t\t\teventData: notification\n\t\t\t}"
                  }
                ],
                staticClass: "notification-card__dismiss-btn",
                attrs: { "data-id": "notification-dismiss-button" },
                on: { click: _vm.dismissAction }
              },
              [_vm._v(" Dismiss ")]
            )
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }